/**
 * Pool-pricing contracts. These mirror the locates-ws `/v1/inventory`
 * pricing endpoints (`model/pool-pricing.ts` and
 * `servers/http/contracts/inventory.ts`). The backend deliberately types
 * these on the model rather than publishing them via
 * `@thinkalpha/locates-ws-client`, so the mirror stays. The locate-price
 * index contracts (`SymbolPricesResponse` et al.) ARE published by the
 * client package and are imported from there.
 */
/** Every {@link PoolPricingMethod}, for iteration in UI code. */
export const POOL_PRICING_METHODS = ['admin', 'cached', 'reference', 'fair-value'];
/** Every {@link BorrowStatusKey}, in the design's display order. */
export const BORROW_STATUS_KEYS = ['ETB', 'Locate Required', 'Preborrow'];
//# sourceMappingURL=lab-pool-pricing.js.map